import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function ATextContainer({
	title,
	description,
	className,
	translate,
	dangerouslyDescription,
}) {
	const translateTitle = translate ? <FormattedMessage id={title} defaultMessage="" /> : title;
	const translateDescription = translate ? <FormattedMessage id={description} defaultMessage="" /> : description;
	const descriptionHtml = dangerouslyDescription ?
		<div dangerouslySetInnerHTML={{ __html: description }} /> : <p>{translateDescription}</p>;


	return (
		<article className={`a-product-detail ${className}`}>
			<h2>{translateTitle}</h2>
			{descriptionHtml}
		</article>
	);
}

ATextContainer.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string.isRequired,
	className: PropTypes.string,
	translate: PropTypes.bool,
	dangerouslyDescription: PropTypes.bool,
};

ATextContainer.defaultProps = {
	className: '',
	translate: true,
	dangerouslyDescription: false,
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.text-container.js